import { rem } from 'polished'
import styled from 'styled-components'

export const Text = styled.p`
  line-height: 1.5;

  ${({ color, theme }) =>
    color &&
    `
      color: ${theme.colors[color]};
  `}

  ${({ size }) =>
    size &&
    `
      font-size: ${rem(size)};
  `}

  ${({ marginTop }) =>
    marginTop &&
    `
    margin-top: ${marginTop}px;
  `}

  ${({ marginBottom }) =>
    marginBottom &&
    `
    margin-bottom: ${marginBottom}px;
  `}

  ${({ appearance, theme }) => {
    if (appearance === 'info') {
      return `
        letter-spacing: -2px;
        font-weight: normal;
        font-family: ${theme.font[1]};
      `
    }

    if (appearance === 'tag') {
      return `
        letter-spacing: 1px;
        font-weight: normal;
        font-family: ${theme.font[1]};
      `
    }
  }}
`
